class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.render();
    this._onScrollThrottled = this._throttle(this.onScroll.bind(this), 100);
  }

  _throttle(fn, limit) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        fn.apply(this, args);
      }
    };
  }

  connectedCallback() {
    window.addEventListener("scroll", this._onScrollThrottled, { passive: true });
    this.querySelector("button.back-to-top_btn").addEventListener(
      "click",
      this.onClick.bind(this)
    );
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this._onScrollThrottled);
    this.querySelector("button.back-to-top_btn").removeEventListener(
      "click",
      this.onClick.bind(this)
    );
  }

  onScroll() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPosition =
      window.scrollY ||
      document.body.scrollTop ||
      document.documentElement.scrollTop;

    if (
      scrollPosition >= 50 &&
      scrollPosition <= documentHeight - windowHeight
    ) {
      this.classList.add('back-to-top__visible');
    } else if (scrollPosition >= documentHeight - windowHeight) {
      this.classList.add('back-to-top__visible');
    } else {
      this.classList.remove('back-to-top__visible');
    }
  }

  onClick() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  render() {
    this.innerHTML = `
      <button class="back-to-top_btn" aria-label="Scroll to top">
        <svg width="15" height="14" viewBox="0 0 15 14" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1.92115L1.2077 7.71347L0.5 7L7.5 -3.0598e-07L14.5 7L13.7923 7.71348L8 1.92115L8 14L7 14L7 1.92115Z" fill="white"/>
        </svg>
      </button>
    `;
  }
}

customElements.define("back-to-top", BackToTop);
